import { render, staticRenderFns } from "./SalesDashboardAdChart.vue?vue&type=template&id=4ea995ed&"
import script from "./SalesDashboardAdChart.vue?vue&type=script&lang=js&"
export * from "./SalesDashboardAdChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports